import { createStore } from '@stencil/store';
import { ReschedulingState } from 'types';
import { ReschedulingCardResponse } from '../client/types';

const { state, onChange, on, set, reset } = createStore<ReschedulingState>({
  accepted: false,
  showOriginal: false,
  rescheduling: {} as ReschedulingCardResponse,
});

window.document.addEventListener('reset-chat-stores', () => {
  reset();
});

export default state;
